import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  InputAdornment,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { Person, Email, LocationOn, Phone, Visibility, VisibilityOff } from "@mui/icons-material";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";



const UserProfilePage: React.FC = () => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [userId, setUserId] = useState<number | null>(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const decoded: any = jwtDecode(token);
    setUserId(decoded.id);

    fetch(`${process.env.REACT_APP_API_BASE_URL}/user/${decoded.id}`, {
      headers: {
        "x-api-key": token,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch user data");
        }
        return res.json();
      })
      .then((data) => {
        if (data) {
          setName(data.name || "");
          setAddress(data.address || "");
          setEmail(data.email || "");
          setPhoneNumber(data.phone_number || "");
        }
      })
      .catch((error) => {
        console.error("Failed to fetch user data:", error);
      });
  }, []);

  const handleSubmit = () => {
    if (!userId) return;

    const token = localStorage.getItem("token");
    if (!token) return;
    if (password && password !== confirmPassword) {
      setPasswordError(true);
      return;
    } else {
      setPasswordError(false);
    }


    const updatedUser = {
      name,
      address,
      email,
      phone_number,
      ...(password && { password }),
    };

    fetch(`${process.env.REACT_APP_API_BASE_URL}/user/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": token,
      },
      body: JSON.stringify(updatedUser),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to update user");
        }
        return res.json();
      })
      .then((data) => {
        alert("Profile updated successfully!");
        console.log("User  updated:", data);
      })
      .catch((error) => {
        console.error("Error updating user:", error);
        alert("Failed to update profile.");
      });
  };

  const textFieldStyles = {
    input: { color: "black" },
    label: { color: "black" },
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "black" },
      "&:hover fieldset": { borderColor: "red" },
      "&.Mui-focused fieldset": { borderColor: "red" },
    },
  };

  return (
    <Box>
      <Button
        variant="outlined"
        sx={{ mt: 2, ml: 2 }}
        onClick={() => navigate(-1)}
      >
        Back
      </Button>

      <Box
        sx={{
          width: "100%",
          maxWidth: 500,
          mx: "auto",
          mt: 5,
          p: 3,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: "#fff",
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", color: "red" }}
        >
          My Profile
        </Typography>

        <TextField
          margin="dense"
          label="Name"
          fullWidth
          disabled
          value={name}
          onChange={(e) => setName(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Person />
              </InputAdornment>
            ),
          }}
          sx={textFieldStyles}
        />

        <TextField
          margin="dense"
          label="Email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Email />
              </InputAdornment>
            ),
          }}
          sx={textFieldStyles}
        />

        <TextField
          margin="dense"
          label="Address"
          fullWidth
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <LocationOn />
              </InputAdornment>
            ),
          }}
          sx={textFieldStyles}
        />

        <TextField
          margin="dense"
          label="Phone Number"
          fullWidth
          value={phone_number}
          onChange={(e) => setPhoneNumber(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Phone />
              </InputAdornment>
            ),
          }}
          sx={textFieldStyles}
        />

        <TextField
          autoComplete="off"
          margin="dense"
          label="Password"
          type={showPassword ? "text" : "password"}
          fullWidth
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} sx={{ padding: 0 }}>
                  {showPassword ? (
                    <VisibilityOff sx={{ color: "red" }} />
                  ) : (
                    <Visibility sx={{ color: "black" }} />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            input: { color: "black" },
            label: { color: "black" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "red" },
              "&:hover fieldset": { borderColor: "darkred" },
              "&.Mui-focused fieldset": { borderColor: "darkred" },
            },
          }}
        />


        <TextField
          margin="dense"
          label="Confirm Password"
          type={showConfirmPassword ? "text" : "password"}
          fullWidth
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
            if (password && e.target.value !== password) {
              setPasswordError(true);
            } else {
              setPasswordError(false);
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} sx={{ p: 0 }}>
                  {showPassword ? (
                    <VisibilityOff sx={{ color: "red" }} />
                  ) : (
                    <Visibility sx={{ color: "black" }} />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            input: { color: "black" },
            label: { color: "black" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "red" },
              "&:hover fieldset": { borderColor: "darkred" },
              "&.Mui-focused fieldset": { borderColor: "darkred" },
            },
          }}
        />
        {passwordError && (
          <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
            Passwords do not match!
          </Typography>
        )}

        <Button
          fullWidth
          variant="contained"
          sx={{
            mt: 2,
            background:
              "linear-gradient(144deg, #FC8545 0%, #FD1D1D 50%, rgba(252,133,69,0.87) 100%)",
            color: "white",
          }}
          onClick={handleSubmit}
        >
          Update Profile
        </Button>
      </Box>
    </Box>
  );
};

export default UserProfilePage;